import { InputLabel, MenuItem, FormControl, Select, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { API_GET, DBRequest, useConfig } from '../../../api/api';
import TypeSkeleton from './TypeSkeleton';
import FormHelperText from '../FormHelperText';
import { useTranslation } from 'react-i18next';

const TypeProductCategory = ({
  updateValidationOnChange,
  dataCollection,
  field,
  errors,
}) => {
  const { t } = useTranslation();
  const [categories, setCategories] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [selected, setSelected] = useState([]);

  const config = useConfig();
  useEffect(() => {
    if (!config) return;
    setIsLoading(true);
    DBRequest({
      config,
      path: 'productcategories',
      method: API_GET,
      onResponse: handleSelected,
      //onLoading: setIsLoading,
    });
  }, [config]);

  function handleSelected(res) {
    const selection = dataCollection[field.readKey]?.map((el) => el.id);

    setSelected(selection);
    setCategories(res);
    setIsLoading(false);
  }

  function handleSelect(e) {
    if (e.target.value.includes(undefined)) {
      updateValidationOnChange(field.key, []);
      return;
    }
    setSelected(e.target.value);
    updateValidationOnChange(field.key, e.target.value);
  }

  return (
    <>
      {isLoading ? (
        <TypeSkeleton />
      ) : (
        <FormControl fullWidth>
          <InputLabel id="category-label">{field.label}</InputLabel>
          <Select
            name="productCategoriesId"
            labelId="category-label"
            label={field.label}
            value={
              selected
              //dataCollection[field.readKey] ? dataCollection[field.readKey] : []
            }
            onChange={handleSelect}
            multiple // added to enable multi-select
          >
            <MenuItem>{t('No Category')}</MenuItem>
            {categories.data.map((category) => (
              <MenuItem key={category.id} value={category.id}>
                {category.name}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText />
        </FormControl>
      )}
    </>
  );
};

export default TypeProductCategory;
